import script from "./Environment.vue?vue&type=script&setup=true&lang=js"
export * from "./Environment.vue?vue&type=script&setup=true&lang=js"

import "./Environment.vue?vue&type=style&index=0&id=2cbe5c62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cbe5c62"]])

export default __exports__